import SkeletonUserComment from './SkeletonUserComment.vue'

export default SkeletonUserComment
